<template>
	<el-config-provider :locale="locale">
		<TheHeader />
		<main :id="id" :class="{ detailpage: $route.meta && $route.meta.detail === true }">
			<router-view :key="$route.fullPath" />
		</main>
		<TheFooter />

		<!-- drawers -->
		<SearchDrawer v-if="isLoggedIn" />
		<CookieBanner />
	</el-config-provider>
</template>

<script>
import { computed, defineComponent } from 'vue';
import TheHeader from './components/TheHeader.vue';
import TheFooter from '@/components/TheFooter.vue';
import SearchDrawer from '@/components/SearchDrawer.vue';
import CookieBanner from '@/components/CookieBanner.vue';
import { ElConfigProvider } from 'element-plus';
import de from 'element-plus/es/locale/lang/de';
import locale_de from 'dayjs/locale/de';
import { useStore, authUser } from './store';
import { checkIsMobile } from './utils/functions';
import { version } from '../package.json';

import '@/scss/main.scss';

export default defineComponent({
	name: 'App',
	data() {
		return {
			locale: de,
		};
	},
	components: {
		TheHeader,
		TheFooter,
		SearchDrawer,
		ElConfigProvider,
		CookieBanner,
	},
	computed: {
		id() {
			let pathname = this.$route.path.split('/')[1];

			if (pathname === '') {
				pathname = 'dashboard';
			}

			return pathname;
		},
		isLoggedIn() {
			return this.loggedin && this.user !== null;
		},
	},
	setup() {
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);

		return {
			store,
			loggedin,

			user: authUser,
		};
	},
	methods: {
		setEnvironment() {
			if (location.host.includes('werberat.klickdrauf.at')) {
				this.$store.commit('setEnvironment', 'abnahme');
			} else if (location.host.includes('beschwerde.werberat.at')) {
				this.$store.commit('setEnvironment', 'production');
			} else {
				this.$store.commit('setEnvironment', 'development');
			}

			// TODO Production
		},
		setIsMobile() {
			const isMobile = checkIsMobile();
			this.$store.commit('setIsMobile', isMobile);

			if (isMobile === false) {
				document.body.classList.remove('is-fixed');
			}
		},
		adjustSliderHeights() {
			const adjustHeight = () => {
				// Select all elements with the class 'slider--boxes'
				const sliderBoxes = document.querySelectorAll('.slider--boxes');

				if (sliderBoxes.length > 0) {
					sliderBoxes.forEach((slider) => {
						const swiperWrapper = slider.querySelector('.swiper-wrapper');
						const slides = slider.querySelectorAll('.swiper-slide');

						if (slides.length > 0) {
							const maxHeight = Math.max(...Array.from(slides).map((sl) => sl.offsetHeight));

							// Set the height of the swiperWrapper element to the max height
							swiperWrapper.style.height = `${maxHeight}px`;
						}
					});
				} else {
					// If no slider elements are found, keep checking
					requestAnimationFrame(adjustHeight);
				}
			};

			// Start checking for the sliders
			adjustHeight();
		},
	},
	created() {},
	mounted() {
		this.setEnvironment();
		this.setIsMobile();
		window.addEventListener('resize', this.setIsMobile);

		this.adjustSliderHeights();
		console.log(`Version: ${version}`);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.setIsMobile);
	},
});
</script>
